/**
 * Higher or Lower (Warmup) — client constants. Colors reuse the shared Warmup palette; only the
 * green/red higher-lower accents + testIDs live here. Mirrors server/src/constants/higherLower for the
 * coin-cap display figures (server stays the source of truth for what's actually awarded).
 */

import { WARMUP_COLORS } from './warmup.constants';

export const HILO_GAME_KEY = 'HILO';

/** Display figures (server authoritative). */
export const HILO_DAILY_COIN_CAP = 10; // "x / 10" coin progress
export const HILO_COINS_PER_CORRECT = 5;

export type HiloChoice = 'higher' | 'lower';

/** Exposed "ledge" (px) under each raised chip button — mirrors the Wordle tile/keyboard idiom. */
export const HILO_CHIP_LEDGE = 4;

export const HILO_COLORS = {
  higherTop: '#86F0C8',
  higher: WARMUP_COLORS.green, // #6EE7B7
  higherShadow: '#1F8A5B',
  lowerTop: '#F9A0A0',
  lower: WARMUP_COLORS.danger, // #F87171
  lowerShadow: '#B03434',
  vsBorder: '#2A2238',
  // Baseline (known) card — brighter purple→slate diagonal (design "TOP" card).
  cardGradientTop: '#2A1F3D',
  cardGradientBottom: '#1F2937',
  // Challenger (mystery) card — deeper, flatter purple diagonal (design "BOTTOM" card).
  cardChallengerTop: '#221A33',
  cardChallengerBottom: '#1B1526',
  cardShadow: '#000000',
  retiredPillBg: '#241C2B',
} as const;

export const HILO_TEST_IDS = {
  view: 'hilo-view',
  baselineCard: 'hilo-baseline-card',
  challengerCard: 'hilo-challenger-card',
  statValue: 'hilo-stat-value',
  coverageLabel: 'hilo-coverage-label',
  retiredPill: 'hilo-retired-pill',
  streak: 'hilo-streak',
  coinProgress: 'hilo-coin-progress',
  higherButton: 'hilo-higher-button',
  lowerButton: 'hilo-lower-button',
  capBanner: 'hilo-cap-banner',
  resultOverlay: 'hilo-result-overlay',
  playAgain: 'hilo-play-again',
} as const;
